import { fetchJobLogJson } from './fetch_json';

export const getJobLog = (id, baseUrl = '/job_logs') => fetchJobLogJson(`${baseUrl}/${id}`);
